import React from 'react';
const Playground = () => {
    return (<div>
            this is the playground - Ideally components will be put here in the
            future. for now this is just to setup the route
        </div>);
};
export default Playground;
